class FGCountdownTimer extends HTMLElement {
  #intervalId = null;

  connectedCallback() {
    const targetDate = this.dataset.targetDate;
    if (!targetDate) return;

    this.#startCountdown(new Date(targetDate).getTime());

    document.addEventListener('shopify:section:load', () => {
      const date = this.dataset.targetDate;
      if (date) {
        this.#cleanup();
        this.#startCountdown(new Date(date).getTime());
      }
    });

    document.addEventListener('shopify:section:unload', () => this.#cleanup());
  }

  disconnectedCallback() {
    this.#cleanup();
  }

  #startCountdown(countdown) {
    const daysEl = this.querySelector('[data-days]');
    const hoursEl = this.querySelector('[data-hours]');
    const minutesEl = this.querySelector('[data-minutes]');

    if (!daysEl || !hoursEl || !minutesEl) return;

    if (Number.isNaN(countdown)) {
      daysEl.textContent = '--';
      hoursEl.textContent = '--';
      minutesEl.textContent = '--';
      return;
    }

    const update = () => {
      const now = Date.now();
      const distance = countdown - now;

      if (distance <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        this.#cleanup();

        if (this.dataset.hideOnExpiry === 'true') {
          this.closest('.shopify-section')?.remove();
        }
        return;
      }

      const day = 1000 * 60 * 60 * 24;
      const hour = 1000 * 60 * 60;
      const minute = 1000 * 60;

      daysEl.textContent = String(Math.floor(distance / day)).padStart(2, '0');
      hoursEl.textContent = String(Math.floor((distance % day) / hour)).padStart(2, '0');
      minutesEl.textContent = String(Math.floor((distance % hour) / minute)).padStart(2, '0');
    };

    update();
    this.#intervalId = setInterval(update, 1000);
  }

  #cleanup() {
    if (this.#intervalId) {
      clearInterval(this.#intervalId);
      this.#intervalId = null;
    }
  }
}

if (!customElements.get('fg-countdown-timer')) {
  customElements.define('fg-countdown-timer', FGCountdownTimer);
}
